import cx from 'classnames';
import React, { useCallback } from 'react';
import List from '../../wui-list/src/index';
import { CalendarSliderProps, EventObjectInput } from './iCalendar';
import moment, {Moment} from 'moment';
import i18n from './i18n/lang';

// function noop() {
// }
// 显示整点的偏移高度
const offsetHeight = 8;

const CalendarSider: React.FC<CalendarSliderProps> = (props) => {
    const {
        value,
        prefixCls,
        fieldid,
        type,
        onMonthChange,
        localeData = i18n['en-us'],
        showTimeLine,
        hourCellRender,
        hourCellContentRender,
        customInterval,
        onTimeEventsClick
    } = props;
    const getMonthName = useCallback((index: number, localeData: any) => {
	    // const localeData = month.locale(this.props.lang).localeData()
	    return localeData.monthsShort[index];
    }, []);

    const handleMonthChange = useCallback((month: number) => {
	    let newValue = value.clone();
	    newValue = newValue.month(parseInt(month + "", 10));
	    onMonthChange(newValue);
    }, [value, onMonthChange]);

    const monthSiderElement = useCallback((month: number) => {
	    let t = value.clone();
	    const dataSource = [];
	    // 渲染12个月份
	    for (let index = 0; index < 12; index++) {
	        const className = cx({
	            [`${prefixCls}-active-sider-month`]: index === month,
	        })
	        t = t.month(index);
	        dataSource.push(
	            <List.Item fieldid={fieldid ? `${fieldid}_${getMonthName(index, localeData)}` : undefined} key={`${index}`} className={className} onClick={() => handleMonthChange(index)}>
	                {getMonthName(index, localeData)}
	            </List.Item>
	        );
	    }

	    return (
	        <List
	            size="small"
	            dataSource={dataSource}
	            renderItem={item => item}
	        />
	    );
    }, [value, prefixCls, fieldid, localeData, getMonthName, handleMonthChange]);
    // type='hour'时点击sider对应时间触发的事件
    const handleTimeEventsClick = useCallback((e: React.MouseEvent<HTMLElement>, eventValue: EventObjectInput, time: Moment) => {
	    if (onTimeEventsClick) {
	        onTimeEventsClick(e, eventValue, time)
	    }
    }, [onTimeEventsClick]);
    // type='hour'时sider渲染内容
    const hourSiderElement = useCallback(() => {
	    const currentValue = moment(value);
	    const dataSource: JSX.Element[] = [];
	    // customInterval为被24整除的整数，否则走原逻辑
	    let interVal = (24 / customInterval) % 1 == 0 ? 24 / customInterval : 24;
	    let intervalNum = (24 / customInterval) % 1 == 0 ? customInterval : 1;
	    // 渲染24小时
	    [...Array(interVal).keys()].forEach(item => {
	        let [time, hour] = Array(2).fill('');
	        if (item * intervalNum < 10 && item * intervalNum > 0) {
	            time = "0" + item * intervalNum + ":00";
	            hour = "0" + item;
	        } else if (item * intervalNum > 9) {
	            time = item * intervalNum + ":00"
	            hour = String(item)
	        }
	        const currentTop = Number(moment().format('HH')) * 60 + Number(moment().format('mm')) - offsetHeight;
	        const top = item * 60 - offsetHeight;
	        // 当前时间线在整点时间上下15分钟范围内，sider不显示当前时间
	        // if (currentValue.format('YYYY-MM-DD') == moment().format('YYYY-MM-DD')) {
	        //     time = currentTop + 15 > top && currentTop - 15 < top && showTimeLine !== false ? '' : time;
	        // }
	        if (intervalNum === 1) {
	            if (currentValue.format('YYYY-MM-DD') == moment().format('YYYY-MM-DD')) {
	                time = currentTop + 15 > top && currentTop - 15 < top && showTimeLine !== false ? '' : time;
	            }
	        } else {
	            let customCurrentTop = Number(moment().format('HH')) / customInterval * 60 - offsetHeight;
	        	let customTop = item * 60 - offsetHeight;
	            if (currentValue.format('YYYY-MM-DD') == moment().format('YYYY-MM-DD')) {
	                time = customCurrentTop + 15 >= customTop && customCurrentTop - 15 < customTop && showTimeLine !== false ? '' : time;
	            }
	        }
	        // const outPutValue = {start: currentValue.format('YYYY-MM-DD') + ' ' + hour + ':' + '00'};
	        const hourRender = () => {
	            if (hourCellRender) {
	                return hourCellRender(item, !!time);
	            } else if (hourCellContentRender) {
	                return <span className={`${prefixCls}-time-item-span`}>{hourCellContentRender(item, !!time)}</span>;
	            } else {
	                return <span className={`${prefixCls}-time-item-span`}>{time}</span>;
	            }
	        }
	        // 每小时分成4份，一份15分钟
	        for (let i = 1; i < (intervalNum === 1 ? 4 : intervalNum) + 1; i++) {
	            // 只显示整点时间
	            if (i == 1) {
	                let currentHour = item * intervalNum + i - 1 < 10 ? '0' + (item * intervalNum + i - 1) : item * intervalNum + i - 1;
	                const outPutValue = {start: currentValue.format('YYYY-MM-DD') + ' ' + currentHour + ':' + '00'};
	                dataSource.push(
	                    <List.Item fieldid={fieldid ? `${fieldid}_siderTime_${item}_${i}` : undefined} className={`${prefixCls}-time-item`} onClick={(e) => handleTimeEventsClick(e, outPutValue, moment(currentValue.format('YYYY-MM-DD') + ' ' + outPutValue.start))}>
	                        {hourRender()}
	                    </List.Item>
	                )
	            } else {
	                let currentHour = item * intervalNum + i - 1 < 10 ? '0' + (item * intervalNum + i - 1) : item * intervalNum + i - 1;
	                const outPutValueT = intervalNum === 1 ? {start: currentValue.format('YYYY-MM-DD') + ' ' + hour + ':' + String((i - 1) * 15)} : {start: currentValue.format('YYYY-MM-DD') + ' ' + currentHour + ':' + '00'};
	                dataSource.push(
	                    <List.Item fieldid={fieldid ? `${fieldid}_siderTime_${item}_${i}` : undefined} className={`${prefixCls}-time-item`} onClick={(e) => handleTimeEventsClick(e, outPutValueT, moment(currentValue.format('YYYY-MM-DD') + ' ' + outPutValueT.start))}>
	                		<span></span>
	            		</List.Item>
	                )
	            }
	        }
	    })

	    return (
	        <List
	            size="small"
	            dataSource={dataSource}
	            renderItem={item => item}
	        />
	    );
    }, [value, prefixCls, fieldid, showTimeLine, hourCellRender, hourCellContentRender, customInterval, handleTimeEventsClick]);

    const month = value.month();
    const monthSider = type !== 'hour' ? monthSiderElement(month) : hourSiderElement();

    return (
	    <div className={`${prefixCls}-sider`} fieldid={fieldid ? `${fieldid}_slider` : undefined}>
	        {monthSider}
	    </div>
    );
};

export default CalendarSider;
